"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeEnv = exports.mapFacets = exports.isValidResponse = exports.interpolateText = exports.filterUndefinedKeys = exports.filterResultResponse = exports.filterQueryResponse = exports.filterItemResponse = exports.extractItemFromResponse = exports.buildRequestParams = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.entries.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * beehive-helpers.js
 *
 * This file contains helper functions used by beehive connector functions.
 */

var ENVS = {
  stg: ['stg', 'stage', 'staging'],
  prd: ['prd', 'prod', 'production']
};
var objectFromEntries = function objectFromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    acc[key] = value;
    return acc;
  }, {});
};
var filterUndefinedKeys = function filterUndefinedKeys(params) {
  var filtered = Object.entries(params).filter(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
      value = _ref4[0];
    return value !== undefined;
  });
  return objectFromEntries(filtered);
};
exports.filterUndefinedKeys = filterUndefinedKeys;
var isValidResponse = function isValidResponse(response) {
  var status = (response === null || response === void 0 ? void 0 : response._status) || (response === null || response === void 0 ? void 0 : response.status);
  if (status) {
    return ['Completed', 'Success'].indexOf(status) !== -1;
  }
  return false;
};
exports.isValidResponse = isValidResponse;
var filterQueryResponse = function filterQueryResponse(response) {
  if (!isValidResponse(response)) {
    throw {
      message: 'Beehive response error.',
      response: response
    };
  }
  return response;
};
exports.filterQueryResponse = filterQueryResponse;
var filterItemResponse = function filterItemResponse(response) {
  var filteredResponse = filterQueryResponse(response);
  if (!filteredResponse.totalResult) {
    return {
      totalResult: 0
    };
  }
  return _objectSpread(_objectSpread({}, filteredResponse), {}, {
    totalResult: parseInt(filteredResponse.totalResult, 10) || 0
  });
};
exports.filterItemResponse = filterItemResponse;
var mapFacets = function mapFacets() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var categories = {};
  var typeToLabel = {};
  facets.forEach(function (item) {
    if (!categories[item.type]) categories[item.type] = {};
    if (!typeToLabel[item.type]) typeToLabel[item.type] = item.label;
    categories[item.type][item.value] = {
      label: item.value,
      count: parseInt(item.ndocs, 10) || 0
    };
  });
  return Object.keys(categories).reduce(function (acc, type) {
    acc[type] = {
      label: typeToLabel[type],
      facets: categories[type]
    };
    return acc;
  }, {});
};
exports.mapFacets = mapFacets;
var mapEntities = function mapEntities() {
  var entities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return entities.reduce(function (acc, val) {
    var values = val.value.split('|');
    acc[val.name] = values.length > 1 ? values : values[0];
    return acc;
  }, {});
};
var filterResultResponse = function filterResultResponse(response) {
  var filteredResponse = filterItemResponse(response);
  if (!filteredResponse.totalResult) {
    return filteredResponse;
  }
  var flattenedItems = {
    totalResult: filteredResponse.totalResult,
    items: filteredResponse.entries && filteredResponse.entries.item || []
  };
  if (filteredResponse.bin || filteredResponse.entity) {
    return _objectSpread(_objectSpread({}, flattenedItems), {}, {
      bin: mapFacets(filteredResponse.bin || []),
      entity: mapEntities(filteredResponse.entity || [])
    });
  }
  return flattenedItems;
};
exports.filterResultResponse = filterResultResponse;
var extractItemFromResponse = function extractItemFromResponse(response) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (response.items) {
    return response.items[index];
  }
  if (response.entries && response.entries.item) {
    return response.entries.item[index];
  }
  return undefined;
};

// tiny mustache-like helper for text interpolation
exports.extractItemFromResponse = extractItemFromResponse;
var interpolateText = function interpolateText(template, data) {
  return template.replace(/(?:\{\{)(\w+?)(?:\}\})/g, function (m, p1) {
    return data[p1] || '';
  }).replace(/(?:\{\{)([\w.]+?)(?:\}\})/g, function (m, p1) {
    var path = p1.split('.');
    return data[path[0]][path[1]] || '';
  });
};
exports.interpolateText = interpolateText;
var buildRequestParams = function buildRequestParams(defaultParams, callParams) {
  return filterUndefinedKeys(_objectSpread(_objectSpread({}, defaultParams || {}), callParams || {}));
};
exports.buildRequestParams = buildRequestParams;
var normalizeEnv = function normalizeEnv(env) {
  return Object.keys(ENVS).filter(function (key) {
    return ENVS[key].indexOf(env) !== -1;
  }).reduce(function (acc, val) {
    return val;
  }, '');
};
exports.normalizeEnv = normalizeEnv;